<template>
  <div class="controller-mode-wrapper">
    <ul>
      <li
        v-for="item in controllerModes"
        :key="item.number"
      >
        <button
          :id="item.number"
          class="g-btn g-btn--rounded"
          :title="'Operational Modes corresponding to the\nModes available on the actual controller\n\n Click here to set the controller to [' + item.name + ']'"
          :class="[{'active' : item.number === ControllerMode}, 'controller-mode-button-container '+item.number]"
          :value="item.value"
          @click="SelectMode(item)"
        >
          {{ $t(`messages.header.${item.value}`) }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { SocketHandler } from "@/assets/javascript/mixins/Mixins"

export default {
  name: "ControllerMode",
  mixins: [SocketHandler],
  props: {
    ControllerMode: {
      type: Number,
      default: null
    },
    controllerModes: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      hasOpenModal: false,
      LastSelected: "",
      CurrentSelect: ""
    }
  },
  watch: {
    ControllerMode() {
      if (this.LastSelected !== undefined && this.hasOpenModal) {
        this.hasOpenModal = false
        this.$emit("SetPageMessage", {
          target: "CloseModal",
          component: "DialogueModal"
        })
      }
    }
  },
  methods: {
    SelectMode(SelectedValue) {
      if (this.LastSelected.value !== SelectedValue.value) {
        this.SocketMessageSend({
          category: "device",
          command: "set",
          data: { type: "dial", item: SelectedValue.value, lastitem: "" }
        })
        this.SocketMessageSend({ component: "Header", command: "ControlMode" })

        if (!this.hasOpenModal) {
          this.hasOpenModal = true
          this.$emit("SetPageMessage", {
            target: "ShowModal",
            modalData: {
              component: "DialogueModal",
              data: {
                title: this.$t("messages.controllerMode.settingControllerMode"),
                text: this.$t("messages.controllerMode.pleaseStandBy"),
                prefix: "controllermode-open-dialogue-modal-",
                options: [],
                spinner: true
              }
            }
          })
        }
      }
      this.LastSelected = this.CurrentSelect
      this.CurrentSelect = SelectedValue
    }
  }
}
</script>

<style lang="scss">
.controller-mode-wrapper {
  padding: 5px;
  ul {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 20px;
    li {
      display: flex;
      justify-content: center;
      align-items: stretch;
    }
  }
  .g-btn {
    display: inline-block;
    font-size: 12px;
    padding: 6px 8px;
    margin: 0px;
    width: 100%;

    &.active {
      background: $color-button-blue !important;
      color: $color-white;
    }
  }
}

@media screen and (min-width: $bp-mobile) {
  .controller-mode-wrapper {
    ul {
      grid-template-columns: repeat(3, 1fr);
      grid-auto-rows: 1fr;
    }
  }
}
</style>
